import { QueryResult, useQuery, OperationVariables } from '@apollo/client';
import GET_USER_CLASSROOMS from 'graph/queries/classrooms/get-user-classrooms';
import { Classroom } from 'types';

export type ClassroomStoreState = {
  classrooms?: Classroom[];
};

export type ClassroomStoreDispatch = {
  refetch: any;
  poll: any;
  stop: any;
};
export type ClassroomStore = [ClassroomStoreState, ClassroomStoreDispatch];

const useClassroomStore = (variables?: OperationVariables): ClassroomStore => {
  const {
    data,
    refetch: classroomRefetch,
    startPolling: classroomPolling,
    stopPolling: classroomStopPolling,
  }: QueryResult<{ classrooms: Classroom[] }> = useQuery(GET_USER_CLASSROOMS, {
    variables: variables,
    fetchPolicy: 'no-cache',
  });

  return [
    {
      classrooms: data?.classrooms,
    },
    {
      refetch: classroomRefetch,
      poll: classroomPolling,
      stop: classroomStopPolling,
    },
  ];
};

export default useClassroomStore;
